"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { X } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/** Launch-week giveaway banner for signed-out visitors (July 31 promo).
 *  Dismissal persists in localStorage so it never comes back on this
 *  browser, and the whole banner self-expires after PROMO_END so it does
 *  not need a code change to take down. */
const STORAGE_KEY = "promo_credits_banner_dismissed";
const PROMO_END_MS = Date.parse("2026-08-08T03:59:59Z"); // Aug 7, end of day ET

export function PromoCreditsBanner() {
  const { user, loading } = useAuth();
  // Start dismissed so SSR/hydration never flashes the banner before the
  // localStorage check runs (same pattern as ReferralBanner).
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(localStorage.getItem(STORAGE_KEY) === "true");
  }, []);

  if (loading || user || dismissed || Date.now() > PROMO_END_MS) return null;

  return (
    <div className="w-full bg-white px-4 py-1.5 flex items-center justify-center gap-2 border-b border-neutral-200 shrink-0 relative">
      <span className="text-xs sm:text-sm text-neutral-800">
        Launch week: get{" "}
        <span className="font-bold text-black">$50 in free credits</span> when
        you sign up this week. No card required.
      </span>
      <Link
        href="/signup"
        className="text-xs sm:text-sm font-semibold text-black underline underline-offset-2 decoration-neutral-400 hover:decoration-black transition-colors whitespace-nowrap"
      >
        Sign up free
      </Link>
      <button
        onClick={() => {
          localStorage.setItem(STORAGE_KEY, "true");
          setDismissed(true);
        }}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-0.5 hover:bg-neutral-100 rounded transition-colors"
        aria-label="Dismiss"
      >
        <X className="h-3 w-3 text-neutral-500" />
      </button>
    </div>
  );
}
